var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainTrackBackImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 334,
    viewBox: "0 0 434 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434 165.278L285.55 313.728C258.604 340.674 214.915 340.674 187.969 313.728L20.7907 146.55C-6.15546 119.604 -6.15552 75.9151 20.7907 48.969L69.7596 0H403.76L434 30.2407V165.278Z",
    fill: "#D5E8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainTrackBackImage2);
export default __webpack_public_path__ + "static/media/mainTrackBackImage2.afcfef45b092ab714d7b8917448a2306.svg";
export { ForwardRef as ReactComponent };